import type { User } from "@/Modules/Models/Domain/User";

import { getMe, getById } from "@/Services/TherapyApi/Users";
import UserApiToUserTransformer from "@/Modules/Transformers/User/UserApiToUserTransformer";

import useAuthStore from "@/Modules/Auth/Store";

import { isValidString } from "@/Utils/String";
import { hasValue } from "@/Utils/Objects";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";
import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";

const isAuthError = (err: unknown): boolean => {
  const code = isApiError(err) ? err["error_code"] : null;

  return code === ApiErrorCodes.AUTHENTICATION_FAILED;
};

async function getUserDataAH(uuid?: string): Promise<User | undefined> {
  const authStore = useAuthStore();
  const userApiToUserTransformer = new UserApiToUserTransformer();

  if (!hasValue(uuid) || !isValidString(uuid)) {
    try {
      const userData = await getMe();

      return userApiToUserTransformer.transform(userData);
    } catch (error) {
      if (isAuthError(error)) {
        authStore.logout();
      }

      return undefined;
    }
  } else {
    try {
      const userData = await getById(uuid);

      return userApiToUserTransformer.transform(userData);
    } catch (e) {
      if (isApiError(e)) {
        authStore.logout();
      }

      return undefined;
    }
  }
}

export default getUserDataAH;
